import React, { useState } from "react";
import { useAuthContext } from "../../context/AuthContext";
import { changePassword } from "../../services/authService";

const DoiMatKhau = () => {
  const { user, login } = useAuthContext();
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!newPassword || newPassword.length < 6) {
      setError("Mật khẩu phải có ít nhất 6 ký tự.");
      return;
    }
    if (newPassword !== confirmPassword) {
      setError("Mật khẩu xác nhận không khớp.");
      return;
    }
    if (newPassword === "123456") {
      setError("Vui lòng không dùng mật khẩu mặc định.");
      return;
    }

    setLoading(true);
    try {
      await changePassword(newPassword);
      setSuccess(true);
      
      // Đăng nhập lại với MK mới
      setTimeout(async () => {
        await login(user.email, newPassword);
      }, 1500);
    } catch (err) {
      setError("Lỗi: " + err.message);
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div style={{
        display: 'flex', justifyContent: 'center', alignItems: 'center',
        minHeight: '100vh', background: 'linear-gradient(135deg, #1a237e, #0d47a1)', padding: 16
      }}>
        <div style={{
          background: 'white', padding: '40px 28px', borderRadius: 20,
          maxWidth: 420, width: '100%', textAlign: 'center',
          boxShadow: '0 25px 60px rgba(0,0,0,0.3)'
        }}>
          <div style={{ fontSize: 64, marginBottom: 12 }}>✅</div>
          <h2 style={{ color: '#2E7D32', marginBottom: 8 }}>Đổi mật khẩu thành công!</h2>
          <p style={{ color: '#888', fontSize: 14 }}>Đang tự động đăng nhập...</p>
        </div>
      </div>
    );
  }

  return (
    <div style={{
      display: 'flex', justifyContent: 'center', alignItems: 'center',
      minHeight: '100vh', background: 'linear-gradient(135deg, #1a237e, #0d47a1)', padding: 16
    }}>
      <div style={{
        background: 'white', padding: '40px 28px', borderRadius: 20,
        maxWidth: 420, width: '100%', textAlign: 'center',
        boxShadow: '0 25px 60px rgba(0,0,0,0.3)'
      }}>
        <div style={{ fontSize: 48, marginBottom: 8 }}>🔒</div>
        <h2 style={{ color: '#1a237e', marginBottom: 4 }}>Đổi mật khẩu</h2>
        <p style={{ color: '#888', fontSize: 13, marginBottom: 24 }}>
          Đây là lần đầu bạn đăng nhập. Vui lòng đổi mật khẩu mới.
        </p>

        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
          <input type="password" placeholder="Mật khẩu mới (tối thiểu 6 ký tự)"
            value={newPassword} onChange={e => setNewPassword(e.target.value)}
            style={{ padding: '14px', border: '2px solid #e8eaf0', borderRadius: 12, fontSize: 15, outline: 'none' }} autoFocus />
          <input type="password" placeholder="Xác nhận mật khẩu mới"
            value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)}
            style={{ padding: '14px', border: '2px solid #e8eaf0', borderRadius: 12, fontSize: 15, outline: 'none' }} />

          {error && (
            <div style={{ padding: '12px 14px', background: '#fef2f2', border: '1px solid #fecaca', borderRadius: 10, color: '#dc2626', fontSize: 13, textAlign: 'left' }}>
              ⚠️ {error}
            </div>
          )}

          <button type="submit" disabled={loading}
            style={{ padding: 14, background: 'linear-gradient(135deg, #1a237e, #283593)', color: 'white', border: 'none', borderRadius: 12, fontSize: 16, fontWeight: 700, cursor: 'pointer', opacity: loading ? 0.6 : 1 }}>
            {loading ? 'Đang xử lý...' : 'Đổi mật khẩu'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default DoiMatKhau;